export default __webpack_public_path__ + "static/media/a037-student-t3-s3-7.1ca12692.svg";